import React, { Component } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Tabs } from 'antd';
import Asa from './asa'
import Spirit from './spirit'

import '../../Produtos/servicos.css'

export default class Comparativo extends Component {
    constructor(props) {
        super (props)
        this.state = {
            fundo: 'asa',
        }
    }

    componentDidMount = async () => {
        window.scrollTo(0,0);
        window.addEventListener('scroll', this.handleWindowScroll, true)
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleWindowScroll, true)
    }

    handleWindowScroll = () => {
        this.setState({
            fillBackground: window.scrollY > 100
        })
    }

    getTab = tab => {
        if(tab === 1){
            this.setState({
                fundo: 'asa'
            })
        } else {
            this.setState({
                fundo: 'spirit'
            })
        }
    }

    render() {
        return (
            <>
                <div className="insideSec">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h4 className="pageTitle text-white">Compare nossos Fundos</h4>
                            </Col>
                            <Col md={12} className="sobreTabs homeTabs">
                                <Tabs defaultActiveKey="1" centered onChange={this.getTab}>
                                    <Tabs.TabPane tab="Flow Digital Assets Asa" key="1">
                                        <Asa />
                                    </Tabs.TabPane>
                                    <Tabs.TabPane tab="Flow Digital Assets Spirit" key="2">
                                        <Spirit />
                                    </Tabs.TabPane>
                                </Tabs>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}